import React from "react";
import { View } from "react-native";
import Text from "@components/AppText";
import Discount from "@assets/svg/Discount";
import { normalize } from "./metrics";

const DiscountStrip = ({ discount_type, discount }) => {
  let discount_length = discount && discount.length;
  let finalWidth = 58;

  switch (discount_length) {
    case 3:
      finalWidth = 62;
      break;
    case 4:
      finalWidth = 68;
      break;
    case 5:
      finalWidth = 74;
      break;
  }

  if (discount_type == "flat_off") {
    return (
      <View
        style={{
          height: 23.2,
          width: finalWidth,
          position: "absolute",
          zIndex: 2,
          top: -2,
          left: 0,
        }}
      >
        <View>
          <Discount />
        </View>
        <View
          style={{
            // position: "absolute",
            // backgroundColor: "blue",
            paddingLeft: normalize(2),
            position: "absolute",
            alignItems: "center",
            justifyContent: "center",
            height: 22,
            left: 1,
          }}
        >
          <Text
            style={{
              fontSize: normalize(10),
              color: "white",
            }}
          >
            ₹{discount} ऑफ
          </Text>
        </View>
      </View>
    );
  } else if (discount_type == "percent_off") {
    return (
      <View
        style={{
          height: 23.2,
          width: 58,
          position: "absolute",
          zIndex: 2,
          top: -2,
          left: 0,
        }}
      >
        <View>
          <Discount />
        </View>
        <View
          style={{
            // position: "absolute",
            // backgroundColor: "blue",
            paddingLeft: normalize(2),
            position: "absolute",
            alignItems: "center",
            justifyContent: "center",
            height: 22,
            left: 1,
          }}
        >
          <Text
            style={{
              fontSize: normalize(10),
              color: "white",
            }}
          >
            {discount}% ऑफ
          </Text>
        </View>
      </View>
    );
  } else {
    return <></>;
  }
};

export default DiscountStrip;
